export const helpMessages = {
  invoices: {
    quickcreateSaveHelpText: 'When we save this invoice it will move to "in progress".',
    invoiceable: {
      title: 'Invoiceable clients',
      text: 'These are clients you\'ve seen during the active time range.<br/>Clients with a tick may have already been invoiced. <br/>Click the arrow to choose which appointments to invoice them for'
    },
    inProgress: {
      title: 'Invoices in progress',
      text: 'These are invoices that you\'re still working on. You can still edit the details of these appoinments. Click the "send" icon to send this appointment to yourself, or directly to the customer'
    },
    sent: {
      title: 'Sent invoices',
      text: 'Thes are invoices that have already been sent. You can no longer edit them, but your can send them again. Click the tick to mark the invoice as paid'
    },
    quickInvoice: {
      title: 'What is QuickInvoice',
      text: 'QuickInvoice allows you to quickly generate and/or send an invoice for a single appointment'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/help.js